import React from 'react';

import { ButtonLinkType } from '../../graphql-fragments/ButtonLink';
import { NestedEntry, SingleEntry, isNestedEntry } from '../../graphql-fragments/navigationMenu';
import { clsx } from '../../utils/utils';
import ClientPortalButton from './ClientPortalButton';
import ContactUsButton from './ContactUsButton';
import * as styles from './DropDownMenu.module.scss';
import MenuEntry from './MenuEntry';
import NestedMenuEntry from './NestedMenuEntry';
interface DropDownMenuProps {
  entries: Array<SingleEntry | NestedEntry>;
  areasOfExpertiseEntries: Array<SingleEntry>;
  className?: string;
  ctaButton?: ButtonLinkType;
  headerWithOpaqueBackground?: boolean;
  menuSizeCategory: 'huge' | 'large' | 'medium' | 'small';
  onEntryClick?: (entry: SingleEntry | NestedEntry, event: React.MouseEvent<HTMLElement>) => void;
  onCtaButtonClick?: React.MouseEventHandler<HTMLElement>;
}

const DropDownMenu = ({
  entries,
  areasOfExpertiseEntries,
  ctaButton,
  className,
  headerWithOpaqueBackground,
  onEntryClick,
  onCtaButtonClick,
}: DropDownMenuProps): React.ReactElement => {
  return (
    <div
      className={clsx(
        styles.container,
        headerWithOpaqueBackground && styles.headerWithOpaqueBackground,
        className,
      )}
    >
      <div className={styles.contentContainer}>
        {entries.map((entry, i: number) => (
          <div className={styles.mobileEntry} key={i}>
            {isNestedEntry(entry) ? (
              <NestedMenuEntry
                key={i}
                entry={entry}
                areasOfExpertiseEntries={areasOfExpertiseEntries}
                onClick={event => {
                  onEntryClick && onEntryClick(entry, event);
                }}
                isMobile
                headerWithOpaqueBackground={headerWithOpaqueBackground}
              />
            ) : (
              <MenuEntry
                entry={entry}
                headerWithOpaqueBackground={headerWithOpaqueBackground}
                key={i}
                onClick={event => {
                  onEntryClick && onEntryClick(entry, event);
                }}
                isMobile
              />
            )}
          </div>
        ))}

        <div className={styles.mobileEntry}>
          <ClientPortalButton
            isMobile
            headerWithOpaqueBackground={headerWithOpaqueBackground}
            onClick={onCtaButtonClick}
          />
        </div>
      </div>

      <div className={styles.buttonContainer}>
        <ContactUsButton onClick={onCtaButtonClick} />
      </div>
    </div>
  );
};

export default DropDownMenu;
